export default __webpack_public_path__ + "static/media/Menu.255f478c.svg";